/**
 * Builds a venue base URL
 * @param endUrl The end of venue based URL */
export function venueBasedUrl(endUrl: string): string {
  return `api/venue/{venueId}/${endUrl}`;
}
